import { c as _c } from "react/compiler-runtime";
import type { TaskCatalogEntry, TaskSubject } from '@onefootprint/request-types/dashboard';
import { type Dispatch, useReducer } from 'react';
type PickerGroup = 'own' | TaskSubject;
type PickerState = {
  group: PickerGroup;
  query: string;
  /** The template waiting on the author to confirm its inputs and tools. */
  pending: TaskCatalogEntry | null;
  /** The template to refocus once the list is back, since its button unmounted with the list. */
  returnFocusTo?: string;
};
type PickerAction = {
  type: 'showGroup';
  group: PickerGroup;
} | {
  type: 'search';
  query: string;
} | {
  type: 'confirm';
  entry: TaskCatalogEntry;
} | {
  type: 'back';
} | {
  type: 'focusReturned';
} | {
  type: 'reset';
};
const INITIAL_PICKER_STATE: PickerState = {
  group: 'own',
  query: '',
  pending: null
};
const pickerReducer = (state: PickerState, action: PickerAction): PickerState => {
  if (action.type === 'showGroup') return {
    ...state,
    group: action.group
  };
  if (action.type === 'search') return {
    ...state,
    query: action.query
  };
  if (action.type === 'confirm') return {
    ...state,
    pending: action.entry,
    returnFocusTo: undefined
  };
  if (action.type === 'back') return {
    ...state,
    pending: null,
    returnFocusTo: state.pending?.key
  };
  if (action.type === 'focusReturned') return {
    ...state,
    returnFocusTo: undefined
  };
  if (action.type === 'reset') return INITIAL_PICKER_STATE;
  return state;
};
const usePickerState = t0 => {
  const $ = _c(4);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initial = t1;
  let t2;
  if ($[2] !== initial) {
    t2 = {
      ...INITIAL_PICKER_STATE,
      ...initial
    };
    $[2] = initial;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return useReducer(pickerReducer, t2);
};
type PickerDispatch = Dispatch<PickerAction>;
export type { PickerDispatch, PickerGroup, PickerState };
export { INITIAL_PICKER_STATE, pickerReducer, usePickerState };